export default {
  computed: {
    $rules: function () {
      const validate = (predicate, invalidMessageKey) => {
        return (value) => (predicate(value) || this.$t(invalidMessageKey))
      }
      return {
        isRequired: validate(
          value => (Boolean(value) || value === 0),
          'ValidationRules.isRequired'
        ),
        isValidEmail: validate(
          value => Boolean(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(value)),
          'ValidationRules.isValidEmail'
        ),
        isValidPassword: validate(
          value => Boolean(value.length >= 8),
          'ValidationRules.isValidPassword'
        ),
        isPasswordMatch: validate(
          value => Boolean(value[0] === value[1]),
          'ValidationRules.isPasswordMatch'
        ),
        isValidNumber: validate(
          value => Boolean(/^[0-9]+$/.test(value)),
          'ValidationRules.isValidNumber'
        ),
        isPercent: validate(
          value => Number(value) >= 0 && Number(value) <= 100,
          'ValidationRules.isPercent'
        )
      }
    }
  }
}
